<template>
  <div>
    <base-header class="pb-6">
      <b-row class="py-4">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
        </b-col>
        <b-col class="text-right">
          <router-link to="../../Home" class="btn btn-neutral btn-sm">
            Documents
          </router-link>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <div class="card-wrapper">
        <card>
          <!-- Card header -->
          <table slot="header">
            <tr>
              <td class="pr-3">Project</td>
              <td><h4 class="mb-0">{{ setting.project_name }}</h4></td>
            </tr>
            <tr>
              <td class="pr-3">Site</td>
              <td><h4 class="mb-0">{{ setting.site_name }}</h4></td>
            </tr>
          </table>

          <!-- Card body -->
          <div class="d-flex align-items-baseline justify-content-between">
            <h3>Manage {{ category_name }}</h3>
            <router-link :to="`../New/${level}`" class="btn btn-primary btn-sm" v-if="access.create">
              New {{ category_name }}
            </router-link>
          </div>
          <el-table :data="categories" header-row-class-name="thead-light" cell-class-name="fw-semibold" class="mt-2">
            <el-table-column label="Code" prop="code"/>
            <el-table-column label="Name" prop="name"/>
            <el-table-column label="Actions">
              <template v-slot="{ row }">
                <router-link :to="`../Edit/${row.id}`" class="btn btn-primary btn-sm" v-if="access.show">
                  View / Edit
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'
import { Table, TableColumn } from 'element-ui';
import axios from '@/util/axios'
import { getAccessByModule } from '@/util/access'

export default {
  mixins: [ErrorFunctionMixin],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  data() {
    return {
      title: 'Document Tracking',
      pid: null,
      sid: null,
      level: null,
      setting: {},
      category_name: null,
      categories: [],
      access: {},
    }
  },

  created() {
    this.pid = this.$route.params.pid
    this.sid = this.$route.params.sid
    this.level = this.$route.params.level
    this.access = getAccessByModule('DOC_REPO_REVIEW')

    this.loadSetting()
    this.loadCategories()
  },

  methods: {
    loadSetting() {
      axios.get(`doc_repo/p/${this.pid}/s/${this.sid}/setting`)
        .then(response => {
          this.setting = response.data.data
          this.category_name = this.setting[`category${this.level}_name`]
        })
        .catch(error => {
          this.errorFunction(error, this.title)
        })
    },

    loadCategories() {
      axios.get(`doc_repo/p/${this.pid}/s/${this.sid}/category`)
        .then(response => {
          const categories = response.data.data
          this.categories = categories.filter(x => x.level == this.level)
        })
        .catch(error => {
          this.errorFunction(error, this.title)
        })
    },
  },
}
</script>
